webpackJsonp([1],{

/***/ "1a0f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = doRequest;

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__("hKoQ").polyfill();
function doRequest(url, data) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'post';

  // 如果是安卓并且预加载，那么不做任何请求
  // if(querystring.platform=="android" && querystring.preload==1){
  //   return new Promise((resolve, reject) => {reject()});
  // }
  var GlobalF10APIHost = '';
  if (location.protocol.indexOf('http') < 0) {

    GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com';
  } else {
    //GlobalF10APIHost = location.protocol + '//' + location.host
    GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com';
    if (location.host.indexOf("localhost") >= 0) {
      //GlobalF10APIHost = 'http://172.30.66.31:12017'
      GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com';
    } else if (location.host.indexOf("172.") >= 0 || location.host.indexOf("10.") >= 0) {
      //GlobalF10APIHost = 'http://172.30.67.105:8008'
      //GlobalF10APIHost = 'http://172.30.67.105:8008'
      GlobalF10APIHost = 'https://emdatahkush5.eastmoney.com';
    }
  }
  url = GlobalF10APIHost + '/api/' + url;
  return (0, _axios2.default)({
    method: method,
    url: url,
    data: data
  });
}

/***/ }),

/***/ "2AsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "33/R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"em-tab"},[_c('ul',{staticClass:"tab-list"},_vm._l((_vm.tabItem),function(item,index){return _c('li',{staticClass:"tab-li",on:{"click":function($event){return _vm.handelSwitch(index)}}},[_c('span',{staticClass:"tab-text",class:{active: index === _vm.actIndex},domProps:{"innerHTML":_vm._s(item)}})])}),0),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6I+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-view"},[_c('div',{staticClass:"picker-container"},[_c('financePicker',{on:{"click":_vm.transferDate}})],1),_vm._v(" "),_c('financeTab',{ref:"childTab",attrs:{"tabItem":_vm.tabItem},on:{"click":_vm.handelClick}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"loading-wrap"},[_c('i'),_vm._v(" "),_c('span',[_vm._v("加载中...")])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activedIndex==0),expression:"activedIndex==0"}],class:['ul-container',(_vm.getItemLen(_vm.XGFXARR.GGData)==0)&&(_vm.XGFXARR.MGData.SSData.length==0)&&(_vm.tabisLoad1)&&(_vm.getItemLen(_vm.CBPLARR.GGData)==0)&&(_vm.getItemLen(_vm.CBPLARR.MGData)==0)&&(_vm.tabisLoad2)&&(_vm.CQQXARR.GGData.length==0)&&(_vm.CQQXARR.MGData.length==0)&&_vm.tabisLoad3?'nodata-container':'']},[(_vm.getItemLen(_vm.XGFXARR.GGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股新股")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l((_vm.XGFXARR.GGData),function(i,j){return (_vm.XGFXARR.GGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type=='1'?"认购中：":"今日上市："))]),_vm._v(" "),_c('ul',_vm._l((_vm.getTenData(_vm.XGFXARR.GGData[j].typeData)),function(item,index){return _c('li',[(i.type=='1')?_c('span',{staticClass:"go-link link-prevent",on:{"click":function($event){return _vm.goTopage()}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]):_vm._e(),_vm._v(" "),(i.type=='2')?_c('span',{staticClass:"go-link",on:{"click":function($event){_vm.compareDate(item.Listingdate)?'':_vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_c('span',{class:_vm.compareDate(item.Listingdate)?'forward-datetext':''},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")])]):_vm._e(),_vm._v(" "),((item.Startdate.length>6&&item.Enddate.length>6)&&(i.type=='1'))?_c('span',{staticClass:"date-text12"},[_vm._v("认购期限："+_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])}),0)]):_vm._e()}),_vm._v(" "),(_vm.XGFXGGTotal>10)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.handelMore(1)}}},[_vm._v("查看更多")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),((_vm.XGFXARR.MGData.SSData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股新股")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v("今日上市：")]),_vm._v(" "),_c('ul',_vm._l((_vm.getTenData(_vm.XGFXARR.MGData.SSData)),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")])])}),0)]),_vm._v(" "),(_vm.XGFXMGTotal>10)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.handelMore(1)}}},[_vm._v("查看更多")]):_vm._e()])]):_vm._e(),_vm._v(" "),(_vm.getItemLen(_vm.CBPLARR.GGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股财报")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l((_vm.CBPLARR.GGData),function(i,j){return (_vm.CBPLARR.GGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type)+"：")]),_vm._v(" "),_c('ul',_vm._l((_vm.getTenData(_vm.CBPLARR.GGData[j].typeData)),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text12"},[(item.Startdate.length>6&&item.Enddate.length>6)?_c('span',[_vm._v(_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])])}),0)]):_vm._e()}),_vm._v(" "),(_vm.CBPLGGTotal>10)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.handelMore(2)}}},[_vm._v("查看更多")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.getItemLen(_vm.CBPLARR.MGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股财报")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l(((_vm.CBPLARR.MGData)),function(i,j){return (_vm.CBPLARR.MGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type)+"：")]),_vm._v(" "),_c('ul',_vm._l((_vm.getTenData(_vm.CBPLARR.MGData[j].typeData)),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),(item.Startdate.length>6&&item.Enddate.length>6)?_c('span',{staticClass:"date-text12"},[_vm._v(_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])}),0)]):_vm._e()}),_vm._v(" "),(_vm.CBPLMGTotal>10)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.handelMore(2)}}},[_vm._v("查看更多")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),((_vm.CQQXARR.GGData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股分红派息")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('ul',[_vm._l((_vm.getTenData(_vm.CQQXARR.GGData)),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text13block"},[_vm._v("每股派息: "+_vm._s(item.Cashamount)+"("+_vm._s(item.Cashcurrency)+")")])])}),_vm._v(" "),(_vm.CQQXGGTotal>10)?_c('li',{on:{"click":function($event){return _vm.handelMore(3)}}},[_vm._v("查看更多")]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),((_vm.CQQXARR.MGData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股分红派息")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('ul',[_vm._l((_vm.getTenData(_vm.CQQXARR.MGData)),function(item,index){return _c('li',{on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_c('span',{staticClass:"go-link"},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text13block"},[_vm._v("每股派息: "+_vm._s(item.Cashamount)+"(USD)")])])}),_vm._v(" "),(_vm.CQQXMGTotal>10)?_c('li',{on:{"click":function($event){return _vm.handelMore(3)}}},[_vm._v("查看更多")]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:((_vm.getItemLen(_vm.XGFXARR.GGData)==0)&&(_vm.XGFXARR.MGData.SSData.length==0)&&(_vm.tabisLoad1)&&(_vm.getItemLen(_vm.CBPLARR.GGData)==0)&&(_vm.getItemLen(_vm.CBPLARR.MGData)==0)&&(_vm.tabisLoad2)&&(_vm.CQQXARR.GGData.length==0)&&(_vm.CQQXARR.MGData.length==0)&&_vm.tabisLoad3),expression:"(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)&&(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)&&(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3"}],staticClass:"no-container"},[_c('i'),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activedIndex==1),expression:"activedIndex==1"}],class:['ul-container',(_vm.getItemLen(_vm.XGFXARR.GGData)==0)&&(_vm.XGFXARR.MGData.SSData.length==0)&&(_vm.tabisLoad1)?'nodata-container':'']},[(_vm.getItemLen(_vm.XGFXARR.GGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股新股")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l((_vm.XGFXARR.GGData),function(i,j){return (_vm.XGFXARR.GGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type=='1'?"认购中：":"今日上市："))]),_vm._v(" "),_c('ul',_vm._l((_vm.XGFXARR.GGData[j].typeData),function(item,index){return _c('li',[(i.type=='1')?_c('span',{staticClass:"go-link link-prevent",on:{"click":function($event){return _vm.goTopage()}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]):_vm._e(),_vm._v(" "),(i.type=='2')?_c('span',{staticClass:"go-link",on:{"click":function($event){_vm.compareDate(item.Listingdate)?'':_vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_c('span',{class:_vm.compareDate(item.Listingdate)?'forward-datetext':''},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")])]):_vm._e(),_vm._v(" "),((item.Startdate.length>6&&item.Enddate.length>6)&&(i.type=='1'))?_c('span',{staticClass:"date-text12"},[_vm._v("认购期限："+_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])}),0)]):_vm._e()}),_vm._v(" "),(_vm.getItemLen(_vm.XGFXARR.GGData)>9 && _vm.XGFXGGMore)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.loadMore('1')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.XGFXGGMore)?_c('li',{staticClass:"sub-li nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),((_vm.XGFXARR.MGData.SSData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股新股")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v("今日上市：")]),_vm._v(" "),_c('ul',[_vm._l((_vm.XGFXARR.MGData.SSData),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")])])}),_vm._v(" "),(_vm.XGFXARR.MGData.SSData.length>9 && _vm.XGFXMGMore)?_c('li',{on:{"click":function($event){return _vm.loadMore('2')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.XGFXMGMore)?_c('li',{staticClass:"nomore-data nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()],2)])])]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:((_vm.getItemLen(_vm.XGFXARR.GGData)==0)&&(_vm.XGFXARR.MGData.SSData.length==0)&&(_vm.tabisLoad1)),expression:"(getItemLen(XGFXARR.GGData)==0)&&(XGFXARR.MGData.SSData.length==0)&&(tabisLoad1)"}],staticClass:"no-container"},[_c('i'),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activedIndex==2),expression:"activedIndex==2"}],class:['ul-container',(_vm.getItemLen(_vm.CBPLARR.GGData)==0)&&(_vm.getItemLen(_vm.CBPLARR.MGData)==0)&&(_vm.tabisLoad2)?'nodata-container':'']},[(_vm.getItemLen(_vm.CBPLARR.GGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股财报")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l((_vm.CBPLARR.GGData),function(i,j){return (_vm.CBPLARR.GGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type)+"：")]),_vm._v(" "),_c('ul',_vm._l((_vm.CBPLARR.GGData[j].typeData),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text12"},[(item.Startdate.length>6&&item.Enddate.length>6)?_c('span',[_vm._v(_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])])}),0)]):_vm._e()}),_vm._v(" "),(_vm.getItemLen(_vm.CBPLARR.GGData)>9 && _vm.CBPLGGMore)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.loadMore('3')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.CBPLGGMore)?_c('li',{staticClass:"sub-li nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),(_vm.getItemLen(_vm.CBPLARR.MGData)>0)?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股财报")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_vm._l(((_vm.CBPLARR.MGData)),function(i,j){return (_vm.CBPLARR.MGData[j].typeData.length>0)?_c('li',{staticClass:"sub-li"},[_c('p',{staticClass:"sub-title"},[_vm._v(_vm._s(i.type)+"：")]),_vm._v(" "),_c('ul',_vm._l((_vm.CBPLARR.MGData[j].typeData),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),(item.Startdate.length>6&&item.Enddate.length>6)?_c('span',{staticClass:"date-text12"},[_vm._v(_vm._s(item.Startdate)+"至"+_vm._s(item.Enddate))]):_vm._e()])}),0)]):_vm._e()}),_vm._v(" "),(_vm.getItemLen(_vm.CBPLARR.MGData)>9 && _vm.CBPLMGMore)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.loadMore('4')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.CBPLMGMore)?_c('li',{staticClass:"sub-li nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:((_vm.getItemLen(_vm.CBPLARR.GGData)==0)&&(_vm.getItemLen(_vm.CBPLARR.MGData)==0)&&(_vm.tabisLoad2)),expression:"(getItemLen(CBPLARR.GGData)==0)&&(getItemLen(CBPLARR.MGData)==0)&&(tabisLoad2)"}],staticClass:"no-container"},[_c('i'),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])])]),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activedIndex==3),expression:"activedIndex==3"}],class:['ul-container',(_vm.CQQXARR.GGData.length==0)&&(_vm.CQQXARR.MGData.length==0)&&_vm.tabisLoad3?'nodata-container':'']},[((_vm.CQQXARR.GGData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title title-purple"},[_vm._v("港股分红派息")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('ul',_vm._l((_vm.CQQXARR.GGData),function(item,index){return _c('li',[_c('span',{staticClass:"go-link",on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text13block"},[_vm._v("每股派息: "+_vm._s(item.Cashamount)+"("+_vm._s(item.Cashcurrency)+")")])])}),0)]),_vm._v(" "),(_vm.CQQXARR.GGData.length>9 && _vm.CQQXGGMore)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.loadMore('5')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.CQQXGGMore)?_c('li',{staticClass:"sub-li nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()])]):_vm._e(),_vm._v(" "),((_vm.CQQXARR.MGData.length>0))?_c('li',{staticClass:"li-container"},[_c('p',{staticClass:"title"},[_vm._v("美股分红派息")]),_vm._v(" "),_c('ul',{staticClass:"sub-ul ggxg"},[_c('li',{staticClass:"sub-li"},[_c('ul',_vm._l((_vm.CQQXARR.MGData),function(item,index){return _c('li',{on:{"click":function($event){return _vm.intoStockNativePage(item.Securityshortname,item.Securitycode,item.Trademarket)}}},[_c('span',{staticClass:"go-link"},[_vm._v(_vm._s(item.Securityshortname)+"("+_vm._s(item.Securitycode)+")")]),_vm._v(" "),_c('span',{staticClass:"date-text13block"},[_vm._v("每股派息: "+_vm._s(item.Cashamount)+"(USD)")])])}),0)]),_vm._v(" "),(_vm.CQQXARR.MGData.length>9 && _vm.CQQXMGMore)?_c('li',{staticClass:"sub-li more-data",on:{"click":function($event){return _vm.loadMore('6')}}},[_vm._v("查看更多")]):_vm._e(),_vm._v(" "),(!_vm.CQQXMGMore)?_c('li',{staticClass:"sub-li nomore-data"},[_vm._v("暂无更多数据")]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:((_vm.CQQXARR.GGData.length==0)&&(_vm.CQQXARR.MGData.length==0)&&_vm.tabisLoad3),expression:"(CQQXARR.GGData.length==0)&&(CQQXARR.MGData.length==0)&&tabisLoad3"}],staticClass:"no-container"},[_c('i'),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("暂无数据")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7aOD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var util = __webpack_require__("y6zN");
var tody = new Date();
exports.default = {
  name: "finance-picker-new",
  props: {
    format: {
      type: String,
      default: "-"
    }
  },
  data: function data() {
    return {
      curDate: tody,
      lineDatalist: [],
      lineMonthDatalist: [],
      selectDate: tody,
      show: false,
      weekList: ["日", "一", "二", "三", "四", "五", "六"]
    };
  },
  created: function created() {
    this.initWeek(tody, true);
  },

  methods: {
    //初始化一周的数据
    initWeek: function initWeek(thisDay, isSelect) {
      this.lineDatalist = [];
      thisDay = thisDay ? thisDay : tody;
      this.curDate = thisDay;
      var nowTime = thisDay.getTime();
      var day = thisDay.getDay();
      var oneDayLong = 24 * 60 * 60 * 1000;
      for (var a = 0; a < 7; a++) {
        var wday = new Date(nowTime - (day - a) * oneDayLong);
        var classStr = "";
        //是否添加自动选中
        if (isSelect && this.compareDate(thisDay, wday)) {
          classStr = " date-now";
          this.selectDate = wday;
        }
        classStr += thisDay.getMonth() == wday.getMonth() ? "" : " prenext-date";
        var single = {
          date: wday,
          classStr: classStr
        };
        this.lineDatalist.push(single);
      }
    },

    //加载月数据
    initMonth: function initMonth(direction) {
      this.animateClass(direction, util.getId("touchBox1"));
      if (direction) {
        this.curDate = direction > 0 ? new Date(this.curDate.setMonth(this.curDate.getMonth() + 1)) : new Date(this.curDate.setMonth(this.curDate.getMonth() - 1));
      }
      this.lineMonthDatalist = [];
      var start = new Date(this.curDate.getFullYear(), this.curDate.getMonth(), 1);
      for (var a = 0; a < 31; a++) {
        var temp = this.addDate(start, a);
        if (temp.getMonth() != this.curDate.getMonth()) {
          break;
        }
        var classStr = "";
        if (this.compareDate(temp, this.selectDate)) {
          classStr = "  date-active";
        }
        this.lineMonthDatalist.push({
          date: temp,
          classStr: classStr
        });
      }
      //补够6行42天
      var first = this.lineMonthDatalist[0].date;
      if (first.getDay() != 0) {
        for (var b = 1; b <= first.getDay(); b++) {
          var addD = this.addDate(first, -b);
          var _classStr = "";
          if (this.compareDate(addD, this.selectDate)) {
            _classStr = "  date-active";
          }
          this.lineMonthDatalist.unshift({
            date: addD,
            classStr: _classStr + " prenext-date"
          });
        }
      }
      var last = this.lineMonthDatalist[this.lineMonthDatalist.length - 1].date;
      if (last.getDay() != 6) {
        var loop = 1;
        for (var b = last.getDay() + 1; b <= 6; b++) {
          var addD = this.addDate(last, loop);
          var _classStr2 = "";
          if (this.compareDate(addD, this.selectDate)) {
            _classStr2 = "  date-active";
          }
          this.lineMonthDatalist.push({
            date: addD,
            classStr: _classStr2 + " prenext-date"
          });
          loop++;
        }
      }
      console.log(this.lineMonthDatalist);
    },

    //左右滑动（月）
    monthClick: function monthClick(direction) {
      this.initMonth(direction);
    },

    //左右滑动（周）
    lineClick: function lineClick(direction) {
      this.animateClass(direction, util.getId("touchBox2"));
      if (direction == 1) {
        var startday = this.lineDatalist[6].date;
        this.lineDatalist = [];
        var lastDay = this.addDate(startday, 7);
        this.curDate = lastDay;
        for (var a = 0; a < 7; a++) {
          var nextDay = this.addDate(startday, a + 1);
          var classStr = "";
          if (this.compareDate(nextDay, this.selectDate)) {
            classStr = " date-now";
          }
          classStr += nextDay.getMonth() == this.curDate.getMonth() ? "" : " prenext-date";
          var single = { date: nextDay, classStr: classStr };
          this.lineDatalist.push(single);
        }
        console.log(this.lineDatalist);
      } else {
        var startday = this.lineDatalist[0].date;
        this.lineDatalist = [];
        var firstDay = this.addDate(startday, -7);

        this.curDate = firstDay;
        for (var a = 0; a < 7; a++) {
          var nextDay = this.addDate(startday, -(7 - a));
          var classStr = "";
          if (this.compareDate(nextDay, this.selectDate)) {
            classStr = " date-now";
          }
          classStr += nextDay.getMonth() == this.curDate.getMonth() ? "" : " prenext-date";
          var single = { date: nextDay, classStr: classStr };
          this.lineDatalist.push(single);
        }
        console.log(this.lineDatalist);
      }
    },

    //周列表选中日期
    selectline: function selectline(selectDay) {
      this.initWeek(selectDay, true);
      this.$emit("click", this.selectDate);
    },

    //月份中选中日期
    selectMonthDay: function selectMonthDay(selectDay) {
      this.selectDate = selectDay;
      this.initWeek(selectDay, true);
      this.initMonth();
      this.$emit("click", this.selectDate);
      this.show = false;
    },

    //显示月份
    showMonth: function showMonth() {
      this.initMonth();
      this.show = true;
    },

    //隐藏月份
    hiddenMonth: function hiddenMonth() {
      var _this = this;

      this.show = false;
      //回填当前月第一周数据，并判断是否有当前选中数据
      var select = this.lineMonthDatalist.find(function (n) {
        return n.date.getFullYear() == _this.selectDate.getFullYear() && n.date.getMonth() == _this.selectDate.getMonth() && n.date.getDate() == _this.selectDate.getDate();
      });
      if (select) {
        this.initWeek(select.date, true);
      } else {
        var firstweek = this.lineMonthDatalist.find(function (n) {
          return n.date.getDay() == 0 && n.classStr == "";
        });
        this.initWeek(firstweek.date, false);
      }
      this.lineMonthDatalist = [];
      //这里肯定没选日期就关闭了，让控件回到原始状态
      // this.initWeek(this.selectDate, true);
      //console.log(this.selectDate);
    },

    //比较两个日期是否相等
    compareDate: function compareDate(d1, d2) {
      var c1 = d1.getFullYear() + "" + d1.getMonth() + "" + d1.getDate();
      var c2 = d2.getFullYear() + "" + d2.getMonth() + "" + d2.getDate();
      if (c1 == c2) {
        return true;
      }
      return false;
    },

    //当前日期加减某天后的日期
    addDate: function addDate(d, add) {
      return new Date(d.getTime() + add * 24 * 60 * 60 * 1000);
    },
    checkSelectWeek: function checkSelectWeek(index) {
      if (!this.selectDate || this.selectDate.getDay() != index) {
        return "";
      }
      for (var s = 0; s < this.lineDatalist.length; s++) {
        if (this.compareDate(this.lineDatalist[s].date, this.selectDate)) {
          return "curline-index";
        }
      }
      return "";
    },
    GetSlideAngle: function GetSlideAngle(dx, dy) {
      return Math.atan2(dy, dx) * 180 / Math.PI;
    },
    GetSlideDirection: function GetSlideDirection(startX, startY, endX, endY) {
      var dy = startY - endY;
      var dx = endX - startX;
      var result = 0;
      //如果滑动距离太短
      if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
        return result;
      }
      var angle = this.GetSlideAngle(dx, dy);
      if (angle >= -45 && angle < 45) {
        result = 4;
      } else if (angle >= 45 && angle < 135) {
        result = 1;
      } else if (angle >= -135 && angle < -45) {
        result = 2;
      } else if (angle >= 135 && angle <= 180 || angle >= -180 && angle < -135) {
        result = 3;
      }
      return result;
    },
    animateClass: function animateClass(flag, obj) {
      if (flag == 1) {
        if (!util.hasClass(obj, "picker-animate2")) {
          util.addClass(obj, "picker-animate2");
          setTimeout(function () {
            util.removeClass(obj, "picker-animate2");
          }, 200);
        }
      } else {
        if (!util.hasClass(obj, "picker-animate1")) {
          util.addClass(obj, "picker-animate1");
          setTimeout(function () {
            util.removeClass(obj, "picker-animate1");
          }, 200);
        }
      }
    },
    getQueryString: function getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURLcomponent(r[2]);return null;
    }
  },
  mounted: function mounted() {
    var touchBox1 = util.getId("touchBox1");
    var touchBox2 = util.getId("touchBox2");
    var that = this,
        startX,
        startY;
    var handel1 = function handel1(event) {
      startX = event.touches[0].pageX;
      startY = event.touches[0].pageY;
    };
    var handel2 = function handel2(event) {
      var endX = void 0,
          endY = void 0;
      endX = event.changedTouches[0].pageX;
      endY = event.changedTouches[0].pageY;
      var direction = that.GetSlideDirection(startX, startY, endX, endY);
      switch (direction) {
        case 0:
          console.log("没滑动");
          break;
        case 1:
          console.log("向上");
          break;
        case 2:
          console.log("向下");
          break;
        case 3:
          that.show ? that.initMonth(1) : that.lineClick(1);
          console.log("向左");
          break;
        case 4:
          console.log("向右");
          that.show ? that.initMonth(-1) : that.lineClick(-1);
          break;
        default:
          break;
      }
    };
    touchBox1.addEventListener("touchstart", handel1, false);
    touchBox1.addEventListener("touchend", handel2, false);
    touchBox2.addEventListener("touchstart", handel1, false);
    touchBox2.addEventListener("touchend", handel2, false);
  }
};

/***/ }),

/***/ "85Mb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue__ = __webpack_require__("7aOD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b1fdda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financePickerNew_vue__ = __webpack_require__("g0h2");
function injectStyle (ssrContext) {
  __webpack_require__("jDur")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financePickerNew_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b1fdda6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financePickerNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ARWx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'tab',
  data: function data() {
    return {
      actIndex: this.activedIndex || 0
    };
  },

  props: {
    tabItem: {
      type: Array,
      default: function _default() {
        return ['选项一', '选项二', '选项三'];
      }
    }
  },
  methods: {
    handelSwitch: function handelSwitch(index) {
      this.actIndex = index;
      this.$emit('click', index);
    }
  }
};

/***/ }),

/***/ "EXcG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * lihaibin  20160420/  东财活动页面统一分享
 * emH5.Share({ 
 *      title: "真送钱！东方财富送你5元现金红包！无门槛！可提现！", 
 *      desc: "热烈祝贺东方财富证券重磅来袭！", 
 *      link: "https://cps.eastmoney.com/Extension/Ttjj/FiveRed", 
 *      imgUrl: "https://cps.eastmoney.com/Extension/images/FiveRed.jpg" 
 * });
 */
var emH5 = window.emH5 || {};
emH5.version = '1.1.0';
window.emH5 = emH5;
//分享设置
emH5.ShareData = {
    title: document.title,
    //  desc: $("meta[name=description]").attr("content"),
    link: window.location.href,
    imgUrl: '',
    fail: function fail(res) {
        alert((0, _stringify2.default)(res));
    }
};
emH5.isios = function () {
    var isIOS = false;
    if (/(iPhone|iPod|iPad|iTouch|iOS)/i.test(navigator.userAgent)) {
        isIOS = true;
    }
    return isIOS;
};
emH5.Share = function (options) {
    /*
     emH5.ShareData = $.extend(emH5.ShareData, options);
     var _url = window.location.href;
     $.getScript((_url[4] == 's' ? "https" : "http") + "://res.wx.qq.com/open/js/jweixin-1.1.0.js", function () {
         $.getJSON((_url[4] == 's' ? "https" : "http") + "://cps.eastmoney.com/emweixin/WX/GetJsSdkUiPackage/3?s=" + encodeURIComponent(_url) + "&cb=?", function (data) {
             wx.config({
                 debug: false,
                 appId: data.AppId,
                 timestamp: data.Timestamp,
                 nonceStr: data.NonceStr,
                 signature: data.Signature,
                 jsApiList: [
                     'checkJsApi',
                     'onMenuShareTimeline',
                     'onMenuShareAppMessage',
                     'onMenuShareQQ',
                     'onMenuShareWeibo'
                 ]
             });
             wx.ready(function () {
                 wx.onMenuShareAppMessage(emH5.ShareData);
                 wx.onMenuShareTimeline(emH5.ShareData);
                 wx.onMenuShareQQ(emH5.ShareData);
                 wx.onMenuShareWeibo(emH5.ShareData);
             });
         });
     });
     window.emH5ShareInfo = function () {
         var jsonfx = '{ "callbackname":"cb_share","type": "all","title": "' + emH5.ShareData.title + '","img": "' + emH5.ShareData.imgUrl + '","url": "' + emH5.ShareData.link + '", "desc": "' + emH5.ShareData.desc + '"}';
         if (emH5.isios()) {
             window.location = "onwebshareclicked:" + jsonfx;
         }
         else if (window.eastmoney) {
             eastmoney.onShareClicked(jsonfx);
         }
     }*/
};

/***/ }),

/***/ "PBQ3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _financeView = __webpack_require__("cS56");

var _financeView2 = _interopRequireDefault(_financeView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: '/',
    name: 'financeView',
    component: _financeView2.default
  }, {
    path: '*',
    redirect: 'financeView'
  }]
});

/***/ }),

/***/ "Pz5c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Q+8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("dH55");

var _App2 = _interopRequireDefault(_App);

var _financecalendar = __webpack_require__("PBQ3");

var _financecalendar2 = _interopRequireDefault(_financecalendar);

var _apiRequest = __webpack_require__("1a0f");

var _apiRequest2 = _interopRequireDefault(_apiRequest);

var _emH5Share = __webpack_require__("EXcG");

var _emH5Share2 = _interopRequireDefault(_emH5Share);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.prototype.$http = _apiRequest2.default;


_vue2.default.config.productionTip = false;

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  router: _financecalendar2.default,
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ "WC7/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WZYi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _financePickerNew = __webpack_require__("85Mb");

var _financePickerNew2 = _interopRequireDefault(_financePickerNew);

var _financeTab = __webpack_require__("sV+Z");

var _financeTab2 = _interopRequireDefault(_financeTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//require('emf/src/js/util/util-nativepi');
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var util = __webpack_require__("y6zN");
var todayDate = new Date(),
    todayYear = todayDate.getFullYear(),
    todayMonth = todayDate.getMonth() + 1,
    todayDay = todayDate.getDate();
exports.default = {
  name: 'finance-view',
  data: function data() {
    return {
      activedIndex: 0,
      tabItem: ['全部', '新股发行', '财报披露', '分红派息'],
      curDate: null,
      XGFXARR: {
        GGData: [{ type: '1', typeData: [] }, { type: '2', typeData: [] }],
        MGData: {
          SSData: []
        }
      },
      XGFXGGTotal: 0,
      XGFXMGTotal: 0,
      CBPLGGTotal: 0,
      CBPLMGTotal: 0,
      CQQXGGTotal: 0,
      CQQXMGTotal: 0,
      CBPLARR: {
        GGData: [{ type: '三季度报告', typeData: [] }, { type: '半年度报告', typeData: [] }, { type: '年度报告', typeData: [] }, { type: '一季度报告', typeData: [] }],
        MGData: [{ type: '开市前', typeData: [] }, { type: '收市后', typeData: [] }, { type: '财报披露', typeData: [] }]
      },
      CQQXARR: {
        GGData: [],
        MGData: []
      },
      XGFXGGPage: 1, XGFXGGMore: true, XGFXMGPage: 1, XGFXMGMore: true, tabisLoad1: false,
      CBPLGGPage: 1, CBPLGGMore: true, CBPLMGPage: 1, CBPLMGMore: true, tabisLoad2: false,
      CQQXGGPage: 1, CQQXGGMore: true, CQQXMGPage: 1, CQQXMGMore: true, tabisLoad3: false,
      isLoading: true
    };
  },

  components: {
    financePicker: _financePickerNew2.default,
    financeTab: _financeTab2.default
  },
  methods: {
    formatUint: function formatUint(num) {},
    goTopage: function goTopage() {
      window.sessionStorage.setItem("curDate", this.curDate);
      //window.location = 'https://hktrade.eastmoney.com/Share/IPO/Index';
      //window.location = this.shareIPOUrl();
    },
    shareIPOUrl: function shareIPOUrl() {
      var IPOUrl = '';
      if (location.protocol.indexOf('http') < 0) {
        IPOUrl = 'https://hktrade.eastmoney.com/Share/IPO/Index';
      } else {
        IPOUrl = 'http://10.10.81.131/Share/IPO/Index';
      }
      return IPOUrl;
    },
    getTenData: function getTenData(arr) {
      if (arr.length > 10) {
        return arr.slice(0, 10);
      }
      return arr;
    },
    compareDate: function compareDate(curDate) {
      var num1 = parseInt(curDate.toString().split("-").join(""));
      var num2 = parseInt([todayYear, util.numLessTen(todayMonth), util.numLessTen(todayDay)].join(""));
      return num1 > num2;
    },
    getItemLen: function getItemLen(array) {
      var count = 0;
      for (var index = 0; index < array.length; index++) {
        count += array[index].typeData.length;
      }
      return count;
    },
    handelMore: function handelMore(flag) {
      this.$refs.childTab.handelSwitch(flag);
      window.scrollTo(0, 0);
    },
    loadMore: function loadMore(flag) {
      switch (flag) {
        case '1':
          if (!this.XGFXGGMore) {
            return;
          }
          this.getData(++this.XGFXGGPage, 10, this.curDate, flag, 1);
          break;
        case '2':
          if (!this.XGFXMGMore) {
            return;
          }
          this.getData(++this.XGFXMGPage, 10, this.curDate, flag, 1);
          break;
        case '3':
          if (!this.CBPLGGMore) {
            return;
          }
          this.getData(++this.CBPLGGPage, 10, this.curDate, flag, 1);
          break;
        case '4':
          if (!this.CBPLMGMore) {
            return;
          }
          this.getData(++this.CBPLMGPage, 10, this.curDate, flag, 1);
          break;
        case '5':
          if (!this.CQQXGGMore) {
            return;
          }
          this.getData(++this.CQQXGGPage, 10, this.curDate, flag, 1);
          break;
        case '6':
          if (!this.CQQXMGMore) {
            return;
          }
          this.getData(++this.CQQXMGMore, 10, this.curDate, flag, 1);
          break;
        default:
      }
    },
    getData: function getData(num, size, dateTime, typeStr, flag) {
      if (flag == 0) {
        num = 1;
      }
      var that = this;
      var time = new Date(dateTime);
      var timestr = time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate();
      debugger;
      this.$http('CJRL/GetEconomicCalendar', { pageSize: size, pageNum: num, dateTime: timestr, typeStr: typeStr }, 'post').then(function (res) {
        that.isLoading = false;
        if (res.data.Status == 0) {
          switch (typeStr) {
            case '1':
              that.tabisLoad1 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.XGFXGGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.XGFXGGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                for (var i = 0; i < that.XGFXARR.GGData.length; i++) {
                  if (that.XGFXARR.GGData[i].type == item.TYPE) {
                    if (item.TYPE == '1' && item.Startdate.length > 6 && item.Enddate.length > 6 || item.TYPE == '2') {
                      that.XGFXARR.GGData[i].typeData.push(item);
                    }
                    continue;
                  }
                }
              });
              break;
            case '2':
              that.tabisLoad1 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.XGFXMGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.XGFXMGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                that.XGFXARR.MGData.SSData.push(item);
              });
              break;
            case '3':
              that.tabisLoad2 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.CBPLGGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.CBPLGGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                for (var i = 0; i < that.CBPLARR.GGData.length; i++) {
                  if (that.CBPLARR.GGData[i].type == item.Sourcetype) {
                    that.CBPLARR.GGData[i].typeData.push(item);
                    continue;
                  }
                }
              });
              break;
            case '4':
              that.tabisLoad2 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.CBPLMGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.CBPLMGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                if (item.Timetype == "--" || !item.Timetype) {
                  that.CBPLARR.MGData[2].typeData.push(item);
                } else {
                  for (var i = 0; i < that.CBPLARR.MGData.length; i++) {
                    // var tempType=item.TYPE=='1'? item.Timetype : item.Sourcetype ;
                    if (that.CBPLARR.MGData[i].type == item.Timetype) {
                      that.CBPLARR.MGData[i].typeData.push(item);
                      continue;
                    }
                  }
                }
              });
              break;
            case '5':
              that.tabisLoad3 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.CQQXGGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.CQQXGGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                that.CQQXARR.GGData.push(item);
              });
              break;
            case '6':
              that.tabisLoad3 = true;
              if (res.data.Result.EconomicCalendarList.length > 0) {
                that.CQQXMGTotal = res.data.Result.EconomicCalendarList[0].TotalCount;
              }
              if (res.data.Result.EconomicCalendarList.length < 10 && flag == 1) {
                that.CQQXMGMore = false;
              }
              res.data.Result.EconomicCalendarList.map(function (item) {
                that.CQQXARR.MGData.push(item);
              });
              break;
            default:
          }
        }
      });
    },
    handelClick: function handelClick(index) {
      this.activedIndex = index;
    },
    transferDate: function transferDate(date) {
      window.sessionStorage.removeItem("curDate");
      this.tabisLoad1 = false;this.tabisLoad2 = false;this.tabisLoad3 = false;
      this.isLoading = true;
      this.curDate = date;
      for (var i = 0; i < this.XGFXARR.GGData.length; i++) {
        this.XGFXARR.GGData[i].typeData = [];
      }
      this.XGFXARR.MGData.SSData = [];
      for (var i = 0; i < this.CBPLARR.GGData.length; i++) {
        this.CBPLARR.GGData[i].typeData = [];
      }
      for (var i = 0; i < this.CBPLARR.MGData.length; i++) {
        this.CBPLARR.MGData[i].typeData = [];
      }
      this.CQQXARR.GGData = [];
      this.CQQXARR.MGData = [];
      this.XGFXGGPage = 1;
      this.XGFXGGMore = true;
      this.XGFXMGPage = 1;
      this.XGFXMGMore = true;
      this.CBPLGGPage = 1;
      this.CBPLGGMore = true;
      this.CBPLMGPage = 1;
      this.CBPLMGMore = true;
      this.CQQXGGPage = 1;
      this.CQQXGGMore = true;
      this.CQQXMGPage = 1;
      this.CQQXMGMore = true;
      this.getData(1, 10, date, '1', 0);
      this.getData(1, 10, date, '2', 0);
      this.getData(1, 10, date, '3', 0);
      this.getData(1, 10, date, '4', 0);
      this.getData(1, 10, date, '5', 0);
      this.getData(1, 10, date, '6', 0);
    },
    intoStockNativePage: function intoStockNativePage(stockName, stockCode, marketCode) {
      //NYSE:纽约证券交易所  NASDAQ:纳斯达克证券市场  AMEX:美国证券交易所  HK:港交所
      window.sessionStorage.setItem("curDate", this.curDate);
      if (AG.InApp) {
        var jsonStr = '{"stockName": "' + stockName + '","stockCode": "' + marketCode + '|' + stockCode + '"}';
        if (AG.ISIOS) {
          window.location = "emH5ToNativePage:" + jsonStr;
        } else {
          eastmoney.emH5ToNativePage(jsonStr);
        }
      } else {
        //分时地址
        if (marketCode == "NYSE" || marketCode == "NASDAQ" || marketCode == "AMEX") {
          location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "7.html";
        } else if (marketCode == "HK") {
          location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "5.html";
        }
      }
    }
  },
  created: function created() {
    var tempDate = window.sessionStorage.getItem("curDate");
    if (tempDate) {
      this.curDate = tempDate;
    } else {
      this.curDate = [todayYear, util.numLessTen(todayMonth), util.numLessTen(todayDay)].join("-");
    }
    this.getData(1, 10, this.curDate, '1', 0);
    this.getData(1, 10, this.curDate, '2', 0);
    this.getData(1, 10, this.curDate, '3', 0);
    this.getData(1, 10, this.curDate, '4', 0);
    this.getData(1, 10, this.curDate, '5', 0);
    this.getData(1, 10, this.curDate, '6', 0);
  },
  mounted: function mounted() {
    if (navigator.userAgent.toLocaleLowerCase().indexOf('color=b') > -1 || location.search.indexOf('color=b') > -1 || navigator.userAgent.toLocaleLowerCase().indexOf('color=d') > -1 || location.search.indexOf('color=d') > -1) {
      document.documentElement.getElementsByTagName('body')[0].className = '';
    }
    if (navigator.userAgent.toLocaleLowerCase().indexOf('color=o') > -1 || location.search.indexOf('color=o') > -1) {
      document.documentElement.getElementsByTagName('body')[0].className = 'orange-skin';
    }
    util.shareFun("港美财经日历", "港美财经日历-东方财富", "东方财富港美财经日历，提供未来最新新股申购上市动向、财报披露状态、分红派息日期等消息。", location.href);
  }
};

/***/ }),

/***/ "cS56":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue__ = __webpack_require__("WZYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b9256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financeView_vue__ = __webpack_require__("6I+H");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b9256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financeView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "dH55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("j558");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701c484e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("2AsX");
function injectStyle (ssrContext) {
  __webpack_require__("WC7/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_701c484e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "g0h2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finance-picker",class:_vm.show?'showpdbtm':''},[_c('table',{staticClass:"date-picker"},[_c('thead',[_c('tr',{staticClass:"date-head"},[_c('th',{attrs:{"colspan":"7"}},[(_vm.show)?_c('i',{staticClass:"icon-menu icon-left",on:{"click":function($event){return _vm.monthClick(-1)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"show-yearmonth"},[_vm._v(_vm._s(_vm.curDate.getFullYear())+"年"+_vm._s(_vm.curDate.getMonth()+1)+"月(北京时间)")]),_vm._v(" "),(_vm.show)?_c('i',{staticClass:"icon-menu icon-right",on:{"click":function($event){return _vm.monthClick(1)}}}):_vm._e(),_vm._v(" "),(_vm.show)?_c('span',{staticClass:"cancel",on:{"click":_vm.hiddenMonth}}):_vm._e(),_vm._v(" "),(!_vm.show)?_c('span',{staticClass:"time-icon",on:{"click":_vm.showMonth}}):_vm._e()])])])]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('tbody',{directives:[{name:"show",rawName:"v-show",value:(!_vm.show),expression:"!show"}],staticClass:"tbody1",attrs:{"id":"touchBox2"}},[_c('tr',_vm._l((_vm.weekList),function(weekname,index){return _c('td',{class:_vm.checkSelectWeek(index)},[_vm._v(" "+_vm._s(weekname)+" ")])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineDatalist),function(item,index){return _c('td',{class:item.classStr,staticStyle:{"height":"30px"},on:{"click":function($event){return _vm.selectline(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])}),0)]),_vm._v(" "),_c('tbody',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"tbody2",attrs:{"id":"touchBox1"}},[_c('tr',_vm._l((_vm.weekList),function(weekname,index){return _c('td',[_vm._v(" "+_vm._s(weekname)+" ")])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(0,7)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(7,14)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(14,21)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(21,28)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(28,35)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0),_vm._v(" "),_c('tr',_vm._l((_vm.lineMonthDatalist.slice(35,42)),function(item,index){return _c('td',[_c('div',{class:item.classStr,on:{"click":function($event){return _vm.selectMonthDay(item.date)}}},[_vm._v(" "+_vm._s(item.date.getDate())+" ")])])}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j558":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

__webpack_require__("c7mj");
exports.default = {
  name: 'app'
};

/***/ }),

/***/ "jDur":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sV+Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue__ = __webpack_require__("ARWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b65cb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financeTab_vue__ = __webpack_require__("33/R");
function injectStyle (ssrContext) {
  __webpack_require__("Pz5c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_financeTab_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24b65cb0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_financeTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "y6zN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function randomNumber(start, end) {
    if (arguments.length === 2) {
        return Math.round(start + Math.random() * (end - start));
    } else if (arguments.length === 1) {
        return Math.round(Math.random() * start);
    } else {
        return Math.round(Math.random() * 100);
    }
}
function trimText(str) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "all";

    switch (type) {
        case 'all':
            return str.replace(/\s+/g, "");
        case 'around':
            return str.replace(/(^\s*)|(\s*$)/g, "");
        case 'left':
            return str.replace(/(^\s*)/g, "");
        case 'right':
            return str.replace(/(\s*$)/g, "");
        default:
            return str.replace(/\s+/g, "");
    }
}
//使用的 时候注意 v-html
function emphasizeText(text, keyword) {
    var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'highlight-text';

    if (!keyword) return text;else {
        var reg = new RegExp(keyword, 'ig');
        return text.replace(reg, "<span class=\"" + className + "\">" + keyword + "</span>");
    }
}
function numLessTen(str) {
    return parseInt(str) < 10 ? '0' + str : str;
}

function addClass(obj, cls) {
    var obj_class = obj.className,
        blank = obj_class != '' ? ' ' : '';
    var added = obj_class + blank + cls;
    obj.className = added;
}
function removeClass(obj, cls) {
    var obj_class = ' ' + obj.className + ' ';
    obj_class = obj_class.replace(/(\s+)/gi, ' ');
    var removed = obj_class.replace(' ' + cls + ' ', ' ');
    removed = removed.replace(/(^\s+)|(\s+$)/g, '');
    obj.className = removed;
}
function hasClass(obj, cls) {
    var obj_class = obj.className,
        obj_class_lst = obj_class.split(/\s+/);
    var x = 0;
    for (x in obj_class_lst) {
        if (obj_class_lst[x] == cls) {
            return true;
        }
    }
    return false;
}
function getId(id) {
    return document.getElementById(id);
}
//分享
__webpack_require__("c7mj");
__webpack_require__("RL31");
function shareFun(pageTitle, shareTitle, shareDesc, shareUrl) {
    if (AG.InApp) {
        //确定标题
        AG.setTitle(pageTitle);
        AG.emH5ShareNeed(1);
        //alert(JSON.stringify(shareUrl));
        //分享
        window.emH5ShareInfo = function () {
            var jsonStr = {
                callbackname: "callbackShare",
                type: "weixin,pengyouquan,weibo,message,email",
                title: shareTitle,
                img: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png",
                url: shareUrl,
                desc: shareDesc
            };

            AG.eventShare(jsonStr);
        };
    } else {
        emH5.Share({
            title: shareTitle,
            desc: shareDesc,
            link: shareUrl,
            imgUrl: "https://emfed.eastmoney.com/public/resource/img/wechatlogo.png"
        });
    }
}
//跳转分时图
function intoStockNativePage(stockName, stockCode, marketCode) {
    if (AG.InApp) {
        var jsonStr = '{"stockName": "' + stockName + '","stockCode": "' + marketCode + "|" + stockCode + '"}';
        if (AG.ISIOS) {
            window.location = "emH5ToNativePage:" + jsonStr;
        } else {
            eastmoney.emH5ToNativePage(jsonStr);
        }
    } else {
        location.href = "http://m2.quote.eastmoney.com/h5stock/" + stockCode + "5.html";
    }
}

module.exports = {
    randomNumber: randomNumber,
    trimText: trimText,
    emphasizeText: emphasizeText,
    numLessTen: numLessTen,
    addClass: addClass,
    removeClass: removeClass,
    hasClass: hasClass,
    getId: getId,
    shareFun: shareFun,
    intoStockNativePage: intoStockNativePage
};

/***/ })

},["Q+8e"]);


// WEBPACK FOOTER //
// static/js/financeCalendar.a1b182fd193c02bd6103.js